// Generated by Melange

import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__Link from "../../components/html/Link.js";
import * as Buhta_cabinet__ManageContractors from "../../components/organisms/Manage/ManageContractors.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__OrgDashboardHeaderMobile from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeaderMobile.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function ManageContractorsPage(Props) {
  let org = Props.org;
  let openMenu = Props.openMenu;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const header = deviceType === "mobile" ? JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeaderMobile.make, {
      title: "Контрагенты",
      leftChildren: JsxRuntime.jsx("img", {
        alt: "buhta-books",
        src: StaticAsset.src("/static/icons/books-white.svg")
      }),
      openMenu: openMenu,
      rightChildren: JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
        route: contextRoute({
          TAG: /* Manage */ 7,
          _0: {
            TAG: /* Contractors */ 0,
            _0: /* Create */ 1
          }
        }),
        className: "bg-links flex rounded-sm px-3 py-2 hover:bg-links-hover active:bg-links-active",
        children: [
          JsxRuntime.jsx("img", {
            src: StaticAsset.src("/static/icons/plus.svg")
          }),
          JsxRuntime.jsx(Buhta_components__Text.H6.make, {
            className: "ml-1 text-white",
            children: "Контрагент"
          })
        ]
      })
    }) : JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
      title: "Контрагенты",
      rightChildren: JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
        route: contextRoute({
          TAG: /* Manage */ 7,
          _0: {
            TAG: /* Contractors */ 0,
            _0: /* Create */ 1
          }
        }),
        className: "bg-links flex rounded-sm px-3 py-2 hover:bg-links-hover active:bg-links-active",
        children: [
          JsxRuntime.jsx("img", {
            src: StaticAsset.src("/static/icons/plus.svg")
          }),
          JsxRuntime.jsx(Buhta_components__Text.H6.make, {
            className: "ml-1 text-white",
            children: "Новый контрагент"
          })
        ]
      })
    });
  return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
    header: header,
    children: JsxRuntime.jsx(Buhta_cabinet__ManageContractors.make, {
      org: org
    })
  });
}

const make = ManageContractorsPage;

export {
  make,
}
/* Buhta_cabinet__DashboardContentTemplate Not a pure module */
